const FINANCIAL_DATA_COMPONENT_TITLE_PROPS = {
  showBuilder: false,
  testId: 'financial-data-title',
};

export { FINANCIAL_DATA_COMPONENT_TITLE_PROPS };
